import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface CreateCommentPayload {
	social_post: string;
	body: string;
	parent_comment?: number | null;
}

const createComment = async (payload: CreateCommentPayload) => {
	const response = await cmsClient.post("/comments/", payload);
	return response.data;
};

const useCreateComment = () => {
	const queryClient = useQueryClient();

	return useMutation(createComment, {
		onSettled: () => {
			queryClient.invalidateQueries(["post-comments"]);
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useCreateComment;
